export function creditcardMask(v: any){
  v = v.replace(/\D/g,""); // Permite apenas dígitos
  v = v.replace(/(\d{4})/g, "$1 "); // Coloca um ponto a cada 4 caracteres
  v = v.replace(/\.$/, ""); // Remove o ponto se estiver sobrando
  v = v.substring(0, 19)// Limita o tamanho

  return v;
}